import type { StatExtend } from '@/type';

/**
 * statExtendClass 배열에서 전체 객체 수를 계산합니다.
 */
export const calculateTotalObject = (
  statExtendClass?: StatExtend[],
): number => {
  return (
    statExtendClass?.reduce(
      (acc, cur) => acc + cur.humanCountValue + cur.aiCountValue,
      0,
    ) ?? 0
  );
};
